export const Filters = {
    isEnabled: 'isEnabled',
    isSelective: 'isSelective'
};

export const paymentMethods = new Map<string, string>([
    ['bancontact', 'Bancontact'],
    ['bizum', 'Bizum'],
    ['blik', 'BLIK'],
    ['boleto', 'Boleto Bancário'],
    ['card', 'Cards'],
    ['sepatransfer', 'Sepa Transfer'],
    ['directbankingeu', 'Direct Banking EU'],
    ['mbway', 'MBWay'],
    ['mobilepay', 'MobilePay'],
    ['multibanco', 'Multibanco'],
    ['neteller', 'Neteller'],
    ['ob', 'Open Banking'],
    ['eps', 'EPS'],
    ['giropay', 'Giropay'],
    ['ideal', 'iDEAL'],
    ['klarnapaynow', 'Klarna Pay Now'],
    ['p24', 'Przelewy24'],
    ['paybybank', 'Pay by Bank'],
    ['payid', 'PayID'],
    ['paysafecard', 'Paysafecard'],
    ['paysafecash', 'Paysafecash'],
    ['pix', 'PIX'],
    ['rapidtransfer', 'Rapid Transfer'],
    ['safetypay', 'SafetyPay'],
    ['skrill', 'Skrill'],
    ['spei', 'SPEI'],
    ['swish', 'Swish'],
    ['trustly', 'Trustly'],
    ['vipps', 'Vipps'],
    ['wero', 'Wero']
]);

export const documentationExcludedPaymentMethodTags = new Set([
    'obt',
    'op',
    'bcmc',
    'directpay',
    'boleto',
    'directbankingeu',
    'paybybank',
    'yaspa'
]);
